import * as React from 'react';
import { useSelector } from 'react-redux';

import { selectOfferId } from '../../../../selectors/offerData/offer';
import { trackIntoView } from './tracking';

export const useTrackIntoView = () => {
  const offerId = useSelector(selectOfferId);

  return React.useCallback((isVisible: boolean) => {
    if (!isVisible) {
      return;
    }

    trackIntoView(offerId);
  }, []);
};
